export default {
  GET_PATIENTS: {
    MOBILE: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description:
          'Sorry, there was an issue fetching your list of patients. Pull down to refresh and try again.'
      }
    },
    WEB: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description: 'Sorry, there was an issue fetching your list of patients.'
      }
    },
    NO_DATA: {
      message: 'There are no patients available for booking.'
    },
    HELPLINE: {
      CovidPatientSelectHelpline: '385-297-6430',
      CovidHelplineHours: '(M-F 7am-8pm, Sat 9am-2pm, Closed Sunday)',
      CovidInfo: 'For technical assistance:'
    }
  }
};
